import { useState } from "react";
import { generateFoodRecommendations } from "../../../../api/foodApi";

const FoodRecommendationAdminPage = ({ onClose }) => {
  const [city, setCity] = useState("Medellín");
  const [department, setDepartment] = useState("Antioquia");
  const [scope, setScope] = useState("CITY");
  const [dryRun, setDryRun] = useState(true);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleGenerate = async () => {
    setRunning(true);
    setErrorMessage("");
    try {
      setResult(
        await generateFoodRecommendations({
          scope,
          city,
          department,
          dryRun,
        })
      );
    } catch (error) {
      setErrorMessage(error.message || "Generation failed.");
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="admin-page food-recommendation-admin-page">
      <header className="admin-page__header">
        <div>
          <p className="admin-page__eyebrow">Food Data</p>
          <h1>Food Recommendations</h1>
          <p className="muted">Rule-based, explainable recommendation generation.</p>
        </div>
        {onClose ? (
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        ) : null}
      </header>

      <section className="panel-card">
        <label className="admin-field">
          Scope
          <select value={scope} onChange={(e) => setScope(e.target.value)}>
            <option value="GLOBAL">GLOBAL</option>
            <option value="CITY">CITY</option>
            <option value="BASKET">BASKET</option>
            <option value="NEIGHBORHOOD">NEIGHBORHOOD</option>
          </select>
        </label>
        <label className="admin-field">
          City
          <input value={city} onChange={(e) => setCity(e.target.value)} />
        </label>
        <label className="admin-field">
          Department
          <input value={department} onChange={(e) => setDepartment(e.target.value)} />
        </label>
        <label className="admin-field">
          <input type="checkbox" checked={dryRun} onChange={(e) => setDryRun(e.target.checked)} />
          Dry run (no database inserts)
        </label>
        <button type="button" className="btn btn--primary" disabled={running} onClick={handleGenerate}>
          {running ? "Running…" : "Generate"}
        </button>
      </section>

      {errorMessage ? <p className="muted">{errorMessage}</p> : null}

      {result ? (
        <pre className="panel-card food-recommendation-admin-page__result">
          {JSON.stringify(result, null, 2)}
        </pre>
      ) : null}
    </div>
  );
};

export default FoodRecommendationAdminPage;
